export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand ${compact ? "brand--compact" : ""}`} aria-label="Shuni, Bangla by ear">
      <span className="brand__latin">
        <span className="brand__monogram" aria-hidden="true">S</span>
        <span>huni</span>
      </span>
      <span className="brand__tagline">Bangla by ear</span>
    </div>
  );
}
